// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"9c3bc5a0","617":"8667f449"}[chunkId] + ".chunk.js";
};